import { useMutation } from '@tanstack/react-query';
import { client } from '@/services/api/axios.ts';

type PostSubscribePushNotificationsResponse = {
  qrCodeUrl: string;
  manualCode: string;
};

export const usePostSubscribePushNotifications = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostSubscribePushNotificationsResponse) => void;
    onError?: (error: unknown) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async (payload: {
      endpoint: string;
      expirationTime?: number | null;
      p256dhKey?: string;
      authKey?: string;
    }) => {
      const deviceInfo = {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenResolution: `${screen.width}x${screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      const { data } = await client.post<{
        body: PostSubscribePushNotificationsResponse;
      }>(`/notifications/subscription`, { ...payload, deviceInfo });

      return data.body;
    },
    onSuccess,
    onError,
  });
};
